/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const co = require('co');

const deps = [
  'bench.main-app',
  require('angular-ui-router'),
  require('ui/web/eventFeed').name,
  require('data/model/client').name,
  require('data/model/dashboardClient').name,
  require('data/collection/clientRequest').name,
];

module.exports = angular
  .module('bench.app.mainapp.messaging', deps)

  .config(($stateProvider, MainAppConfig) => {
    const stateName = 'bench.messaging';
    const path = MainAppConfig.routes[stateName];

    return $stateProvider.state(stateName, {
      url: path,
      resolve: {
        _Client(Client, _User) {
          return co(function* () {
            const client = new Client(_User.getClientId());

            yield client.$promise;
            return client;
          });
        },

        _messages(MessageCollection, _User) {
          return co(function* () {
            const messages = new MessageCollection({
              viewerId: _User.userId,
              clientId: _User.getClientId(),
              full: true,
              roles: _User.roles,
            });

            yield messages.$promise;
            return messages;
          });
        },

        _clientRequests(ClientRequestCollection, _User) {
          return co(function* () {
            const clientRequests = new ClientRequestCollection({ clientId: _User.getClientId() });

            yield clientRequests.$promise;
            return clientRequests;
          });
        },

        _dashboardClient(DashboardClient, _User) {
          return co(function* () {
            const dashboardClient = new DashboardClient(_User.getClientId());

            yield dashboardClient.$fetch();

            return dashboardClient;
          });
        },
      },
      controller($stateParams, _User) {
        this.userId = _User.userId;
        this.clientId = $stateParams.clientId;
        return this;
      },
      controllerAs: 'vm',
      template: `\
<bl-event-feed
  editable="true"
  user-id="vm.userId"
  client-id="vm.clientId">
</bl-event-feed>\
`,
    });
  });
